import * as Yup from "yup"
import { AcademicLevel, Availabilities, CampaignId, Campus, Email, FirstName, LastName, MobilePhone, PostalCodeNotRequired } from "services/validation"

const schema = Yup.object().shape({
  ...Availabilities,
  ...CampaignId,
  lead: Yup.object().shape({
    ...AcademicLevel,
    ...Campus,
    ...Email,
    ...FirstName,
    ...LastName,
    ...MobilePhone,
    ...PostalCodeNotRequired
  })
})

export default schema
